import { AddProjectPayload } from '../../@types/projects/types';

export function validateAddProject(payload: AddProjectPayload) {
  const errors: string[] = [];

  if (!payload.project_name) {
    errors.push('Project name must be filled');
  }


  return errors;
}
